import { formatDateHHMM, formatDateYYYYmmDD } from "../../utils/DatesFns";
import {
  AppointmentReport,
  TrackingReport,
  VolantesReport,
} from "./interfaces/Volantes.interfaces";

export interface RespReport {
  id?: any;
  timeslotDate?: any;
  timeslotStart?: any;
  timeslotEnd?: any;
  docksNum?: any;
  dockCapacity?: any;
  flyer_number?: string;
  ruc_agent?: string;
  custom_agent?: string;
  withdrawal_date?: string;
  payment_flyer?: string;
  payment_preinvoice?: string;
  payment_invoice?: string;
  date_first_consult?: string;
  invoiced_ruc?: string;
  name_invoiced_ruc?: string;
  type_invoiced_ruc?: string;
  preinvoice_creation_date?: string;
  last_date_preinvoice?: string;
  number_sap?: string;
  payment_type?: string;
  type_ruc_payer?: string;
  ruc_payer?: string;
  name_ruc_payer?: string;
  approver_user?: string;
  sap_invoice_number?: string;
  mount_soles?: string;
  mount_dollars?: string;
  compen_user_payment?: string;
  customs_user_participates?: string;
}

export const ReportConvertResponseVolante = (resp: VolantesReport) => {
  const data_report = resp.volantes.map((volante) => {
    const {
      payment_date,
      withdrawal_date,
      quotation_created_at,
      quotation_updated_at,
      volante_created_at,
    } = volante;
    const paymentDate = payment_date ? formatDateYYYYmmDD(payment_date) : "-";
    const withdrawalDate = withdrawal_date
      ? formatDateYYYYmmDD(withdrawal_date)
      : "-";

    const quotationCreatedAt = quotation_created_at
      ? formatDateHHMM(new Date(quotation_created_at))
      : "-";
    const quotationUpdatedAt = quotation_updated_at
      ? formatDateHHMM(new Date(quotation_updated_at))
      : "-";
    const volanteCreatedAt = volante_created_at
      ? formatDateHHMM(new Date(volante_created_at))
      : "-";

    return {
      volante_num: volante.volante_num ? volante.volante_num : "-",
      agent_ruc: volante.agent_ruc ? volante.agent_ruc : "-",
      agent_name: volante.agent_name ? volante.agent_name : "-",
      withdrawal_date: withdrawalDate,
      volante_payment_status: volante.volante_payment_status
        ? volante.volante_payment_status
        : "-",
      quotation_payment_status: volante.quotation_payment_status
        ? volante.quotation_payment_status
        : "-",
      invoice_payment_status: volante.invoice_payment_status
        ? volante.invoice_payment_status
        : "-",
      volante_created_at: volanteCreatedAt,
      billable_ruc: volante.billable_ruc ? volante.billable_ruc : "-",
      billable_ruc_name: volante.billable_ruc_name
        ? volante.billable_ruc_name
        : "-",
      billable_ruc_option: volante.billable_ruc_option
        ? volante.billable_ruc_option
        : "-",
      quotation_created_at: quotationCreatedAt,
      quotation_updated_at: quotationUpdatedAt,
      id_pedido: volante.id_pedido ? volante.id_pedido : "-",
      payment_type: volante.payment_type ? volante.payment_type : "-",
      payer_ruc_option: volante.payer_ruc_option
        ? volante.payer_ruc_option
        : "-",
      payer_ruc: volante.payer_ruc ? volante.payer_ruc : "-",
      payer_ruc_name: volante.payer_ruc_name ? volante.payer_ruc_name : "-",
      user_email_approved_by: volante.user_email_approved_by
        ? volante.user_email_approved_by
        : "-",
      tci_num: volante.tci_num ? volante.tci_num : "-",
      sales_invoice_price_pen: volante.sales_invoice_price_pen
        ? volante.sales_invoice_price_pen
        : "-",
      sales_invoice_price_usd: volante.sales_invoice_price_usd
        ? volante.sales_invoice_price_usd
        : "-",
      compensated_by: volante.compensated_by ? volante.compensated_by : "-",
      user_invoice_full_name: volante.user_invoice_full_name
        ? volante.user_invoice_full_name
        : "-",
      payment_date: volante.payment_date ? paymentDate : "-",
    };
  });
  return {
    data_report,
    num_pages: resp.num_pages,
    page_size: resp.page_size,
    count: resp.count,
  };
};

export const ReportConvertResponseAppoinment = (resp: AppointmentReport) => {
  const data_report = resp.appointments.map((appointment) => {
    const {
      created_at,
      updated_at,
      withdrawal_date,
      timeslot_start,
      timeslot_end,
    } = appointment;
    const createdAt = created_at ? formatDateHHMM(new Date(created_at)) : "-";
    const updatedAt = updated_at ? formatDateHHMM(new Date(updated_at)) : "-";
    const withdrawalDate = withdrawal_date
      ? formatDateYYYYmmDD(withdrawal_date)
      : "-";
    const timeslotStart = timeslot_start
      ? formatDateHHMM(new Date(timeslot_start))
      : "-";
    const timeslotEnd = timeslot_end
      ? formatDateHHMM(new Date(timeslot_end))
      : "-";

    return {
      volante_num: appointment.volante_num ? appointment.volante_num : "-",
      tci_num: appointment.tci_num ? appointment.tci_num : "-",
      factura_num: appointment.factura_num ? appointment.factura_num : "-",
      turn_status: appointment.turn_status ? appointment.turn_status : "-",
      created_at: createdAt,
      updated_at: updatedAt,
      turn_num: appointment.turn_num ? appointment.turn_num : "-",
      vct_id: appointment.vct_id ? appointment.vct_id : "-",
      dock_num: appointment.dock_num ? appointment.dock_num : "-",
      numeric_id: appointment.numeric_id ? appointment.numeric_id : "-",
      timeslot_start: timeslotStart,
      timeslot_end: timeslotEnd,
      withdrawal_date: withdrawalDate,
      custom_dispatcher_full_name: appointment.custom_dispatcher_full_name
        ? appointment.custom_dispatcher_full_name
        : "-",
      custom_dispatcher_document_number:
        appointment.custom_dispatcher_document_number
          ? appointment.custom_dispatcher_document_number
          : "-",
      vehicle_data: appointment.vehicle_data ? appointment.vehicle_data : "-",
      agent_ruc: appointment.agent_ruc ? appointment.agent_ruc : "-",
      agent_name: appointment.agent_name ? appointment.agent_name : "-",
    };
  });
  return {
    data_report,
    num_pages: resp.num_pages,
    page_size: resp.page_size,
    count: resp.count,
  };
};

// TODO: FOR RQ NEXT FOR INTEGRATE WITH BACKEND WHEN ENDPOINT THIS READY
export const ReportConvertResponseTraceability = (resp) => {
  const data_report = resp.timeslots_by_date.map((timeslot) => {
    return {
      id: timeslot.timeslot_by_date_id,
      timeslotDate: timeslot.timeslot_date,
      timeslotStart: timeslot.timeslot_start,
      timeslotEnd: timeslot.timeslot_end,
      docksNum: timeslot.docks_num,
      dockCapacity: timeslot.dock_capacity,
    };
  });
  return {
    data_report,
    num_pages: resp.num_pages,
    page_size: resp.page_size,
    count: resp.count,
  };
};

export const ReportCountConvertResponse = (resp: TrackingReport) => {
  const report_data_count = resp.reports_data.filter(
    (reportData) => reportData.progress < 100
  );

  return {
    report_data_count,
    num_pages: resp.num_pages,
    page_size: resp.page_size,
    count: resp.count,
  };
};
